<template>
  <v-card flat id="create-organization">
    <v-card-title>
      <h6 class="text-h6">{{ $t('title') }}</h6>
    </v-card-title>
    <v-card-text>
      <FormErrors :show="showResourceErrors" :errors="resourceErrors" />
      <v-form>
        <v-text-field
          append-icon="$vuetify.icons.values.organization"
          v-model.trim="form.display"
          :error-messages="displaynameErrors"
          :label="$t('labels.displayName')"
          required
          @input="$v.form.display.$touch()"
          @blur="$v.form.display.$touch()"
        ></v-text-field>
        <LanguageField v-model="form.language" />
      </v-form>
    </v-card-text>
    <v-divider />
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="accent" depressed @click="onNewOrg" :loading="loading" :disabled="loading">{{
        $t('labels.submit')
      }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapState, mapActions } from 'vuex'
import { BaseForm, FormErrors, LanguageField } from '@argon/app/components'
import { NAMESPACE } from '../store'
export default {
  name: 'NewOrganization',
  extends: BaseForm,
  components: {
    FormErrors,
    LanguageField
  },
  props: {
    organization: Object,
    onComplete: { type: Function, required: true },
    autonomous: { type: Boolean, default: false }
  },
  validations: {
    form: {
      display: { required }
    }
  },
  data: () => ({
    form: {
      display: '',
      language: 'en'
    },
    loading: false
  }),
  computed: {
    displaynameErrors() {
      const errors = []
      if (!this.$v.form.display.$dirty) return errors
      !this.$v.form.display.required && errors.push(this.$t('required'))
      this.getServerErrors('display', errors)
      return errors
    }
  },
  methods: {
    ...mapActions(NAMESPACE, ['createOrganization', 'patchSettings']),
    onNewOrg() {
      if (this.$v.form.$invalid) {
        return this.$v.form.$touch()
      }
      if (this.autonomous) {
        this.createOrg()
      } else {
        this.onComplete(this.form)
      }
    },
    createOrg() {
      const payload = {
        display: this.form.display
      }
      this.loading = true
      this.createOrganization(payload)
        .then((org) => {
          let settings = {
            orgId: org.id,
            data: { language: this.form.language }
          }
          this.patchSettings(settings)
            .then(() => {
              this.onComplete(org)
            })
            .catch(this.setServerErrors)
        })
        .catch(this.setServerErrors)
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style></style>
<i18n>
{
  "en": {
    "title": "Organization Details"
  },
  "fr": {
    "title": "Détails de l'organisation"
  }
}
</i18n>
